export default "__VITE_ASSET__fe71bf9a__"